<h1 style="font-size: 1.5em; margin-left: 4rem; margin-bottom: 1.5rem;">Admin - Menu Management</h1>
<div class="row-10 ms-4" style="margin-left: 1.5rem;">
    <div class="col-md-2">
        <menu-tree (menuSelected)="onMenuSelected($event)"></menu-tree>
    </div>

    <div class="col-md-8">
        <menu-form [menuItem]="menuItem" (save)="onSave($event)"></menu-form>
    </div>
</div>